import { Component, Input, OnInit } from '@angular/core';
import { Util } from '@libs/utilities/util';


@Component({
    selector: 'ng-password-visibility',
    templateUrl: './password-visibility.component.html',
    styleUrls: ['./password-visibility.component.scss'],
    standalone: false
})
export class NgPasswordVisibilityComponent implements OnInit {

	//** Input Configurations */
	@Input() element !: HTMLInputElement; 			// html input element
	@Input() inputName: string = 'password';

	//** Configurations */
	readonly ICON_CONTAINER_WIDTH : number = 20;
	readonly ICON_CONTAINER_HEIGHT: number = 20;

	//** Helpers Variables */
	passwordVisibility: boolean = false;


	ngOnInit(): void {

		//0 - check if element is valid
		if (Util.Basic.isUndefined(this.element)) 		 throw new Error(`PasswordVisibilityComponent => ngOnInit => FATAL ERROR: element is required`);
		if (!(this.element instanceof HTMLInputElement)) throw new Error(`PasswordVisibilityComponent => ngOnInit => FATAL ERROR: element must be an instance of HTMLInputElement`);

		//1 - set element position to relative
		this.element.parentElement?.style.setProperty('position', 'relative');
	}

	toggleVisibility(): void {
		this.passwordVisibility = !this.passwordVisibility;
		if (this.passwordVisibility) this.element.type = 'text';
			else this.element.type = 'password';
	}
}
